import React from 'react';
import {BrowserRouter} from "react-router-dom";
import "@glideapps/glide-data-grid/dist/index.css";
import './styles/styles.scss';
import App from './App';
import configureStore from './store/configureStore';
import {Provider} from 'react-redux';
import {createRoot} from 'react-dom/client';

export const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);

// Disable scrolling wheel on number input
document.addEventListener("wheel", function(event){
    if (document.activeElement.type === "number"){
        document.activeElement.blur();
    }
});

root.render((
    <Provider store={store}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>
));
